import {Navigate} from 'react-router';
import {default as SettingsContainer} from './settings';
import {settingsRoutes} from './settings/routes';
import {stationRoutes} from './stations/routes';

export const dashboardRoutes = [
  {
    path: '',
    element: <Navigate to="stations" replace />,
  },
  {
    path: 'stations',
    children: stationRoutes,
  },
  {
    path: 'settings',
    children: settingsRoutes,
    Component: SettingsContainer,
  },
  {
    // Moved to the top-level /forecast-maps (full-width, no nav rail). Keep
    // these redirects so old /app/forecast-maps deep links still resolve.
    path: 'forecast-maps',
    element: <Navigate to="/forecast-maps" replace />,
  },
  {
    path: 'forecast-maps/builder',
    element: <Navigate to="/forecast-maps/builder" replace />,
  },
  {
    path: 'admin/debug',
    lazy: () => import('../../screens/admin/DebugScreen'),
  },
  {
    path: 'admin/debug/dependencies',
    lazy: () => import('../../screens/admin/DependenciesScreen'),
  },
  {
    path: '*',
    lazy: async () => import('../../screens/NotFound'),
  },
];
